export type Locale = 'pl' | 'en'

export const SUPPORTED_LOCALES: readonly Locale[] = ['pl', 'en'] as const

export function detectSupportedLocale(raw: string | undefined | null): Locale {
    if (!raw) return 'pl'
    const lang = raw.split('-')[0]
    return SUPPORTED_LOCALES.includes(lang as Locale) ? (lang as Locale) : 'pl'
}

export interface UserRead {
    id: string
    email: string
    username: string
    provider: string
    is_active: boolean
    is_admin: boolean
    is_verified: boolean
    created_at: string
    locale: Locale
    plan_tier: 'free' | 'weekend_pass' | 'monthly' | null
    /** Backend verdict: user must accept the currently effective terms before using the app. */
    terms_acceptance_required: boolean
}

export interface LoginRequest {
    email: string
    password: string
}

export interface RegisterRequest {
    email: string
    username: string
    password: string
}

/** Which social login providers the backend has credentials for. */
export interface AuthProviders {
    google: boolean
    facebook: boolean
}
